import { z } from "zod";
import { OhipServiceLineSchema } from "./ohip-billing.js";
import { IdSchema, Sha256Schema } from "./primitives.js";
export const OHIP_BILLING_PROMPT_VERSION = "ohip-walk-in-2026-09-24-v2";
export const OhipBillingNoteSchema = z
    .object({
    subjective: z.string().max(20000),
    objective: z.string().max(20000),
    assessment: z.string().max(20000),
    plan: z.string().max(20000),
})
    .strict();
export const OhipBillingRecommendationSchema = z
    .object({
    diagnosticCode: z.string().regex(/^(?:[0-9]{3})?$/),
    diagnosticEvidence: z.string().max(2000),
    rationale: z.string().max(1200),
    services: z
        .array(OhipServiceLineSchema.extend({
        evidence: z.string().min(1).max(2000),
        rationale: z.string().min(1).max(1200),
    }).strict())
        .max(20),
    warnings: z.array(z.string().min(1).max(600)).max(10),
})
    .strict();
export const OhipBillingSuggestionSchema = z
    .object({
    encounterId: IdSchema,
    siteId: IdSchema,
    inputHash: Sha256Schema,
    model: z.string().min(1),
    promptVersion: z.string().min(1),
    recommendation: OhipBillingRecommendationSchema,
})
    .strict();
export const OhipServiceCatalogueEntrySchema = z
    .object({
    code: z.string(),
    active: z.boolean(),
    description: z.string(),
    effectiveFrom: z.string(),
    effectiveTo: z.string().nullable(),
    amountCents: z.number().int().nonnegative().nullable(),
    schedulePage: z.number().int().positive().nullable(),
})
    .strict();
export const OhipServiceSearchSchema = z
    .object({
    items: z.array(OhipServiceCatalogueEntrySchema),
    total: z.number().int().nonnegative(),
    sourceUrl: z.string().url(),
})
    .strict();
export const OhipBillingJobSchema = z
    .object({
    claimId: IdSchema,
    leaseToken: IdSchema,
    note: OhipBillingNoteSchema,
    serviceDate: z.string().date(),
})
    .strict();
//# sourceMappingURL=ohip-billing-agent.js.map